
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hosts/[id]",
      function () {
        return require("private-next-pages/hosts/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hosts/[id]"])
      });
    }
  